/** @format */
import React from 'react'
import Modal from 'react-modal'
import './style.css'

export function TimeoutModal(props) {
  const timeoutModalClasses = {
    base: 'timeout-modal',
    afterOpen: 'timeout-modal--after-open',
    beforeClose: 'timeout-modal--before-close',
  }
  const timeoutModalOverlayClasses = {
    base: 'timeout-modal-overlay',
    afterOpen: 'timeout-modal-overlay--after-open',
    beforeClose: 'timeout-modal-overlay--before-close',
  }
  return (
    <>
      <Modal
        className={timeoutModalClasses}
        overlayClassName={timeoutModalOverlayClasses}
        isOpen={true}
        // onRequestClose={() => {}}
        closeTimeoutMS={500}
      >
        <div className="modal-content">
          <div className="title">TIME’S UP!</div>
          <div className="text">
            You’ve run out of time!
            <br /> Play again and catch 20
            <br /> flavour drops to get a free
            <br /> pack of pods or get your
            <br /> free delivery code below.
          </div>
          <button
            id="btnPlay"
            className="btn btn-primary"
            onClick={props.onFinishGame}
            style={{ margin: '0 auto 20px auto' }}
          >
            Get Your Code
          </button>
          <button
            className="btn btn-secondary"
            onClick={props.onRestartGame}
            style={{ margin: '0 auto 20px' }}
          >
            Play Again
          </button>
        </div>
      </Modal>
    </>
  )
}

export default TimeoutModal
